export default __webpack_public_path__ + "static/media/NOT INTERESTED.903109f5.mp3";